// @flow
import * as React from "react";

import { LoadingOutlined } from "@ant-design/icons";

import classNames from "classnames";

type Props = {
  className?: string,
  size?: "default" | "large",
};

function Spinner({ className, size = "default" }: Props): React.Node {
  return (
    <LoadingOutlined
      spin
      className={classNames(className)}
      style={size === "large" ? { fontSize: "3em" } : undefined}
    />
  );
}

export default Spinner;
